import { formatDateToFirstOfMonth } from './audienceDates';

/**
 * The filters the screen's audience tab sends to `displays/audience/list` (or
 * `displays/audience-fallback/list` for a fallback version). Values are arrays because the API's
 * list filters only accept arrays; a `>=` prefix is a comparison (see the API's
 * `app/Traits/BaseModel/AGENTS.md`).
 */
export const buildAudienceFilters = ({
    audienceVersionId,
    frameId,
    days,
    hour,
    date,
}: {
    audienceVersionId: number;
    frameId: number | string;
    /** JS-style day numbers picked in the Days filter (Monday = 0). */
    days: string[] | number[];
    /** The picked hour ('00'-'23'), or null. */
    hour: string | number | null;
    /** The picked date as 'yyyy-MM-dd', or null. */
    date: string | null;
}): Record<string, any> => ({
    // Loosely typed: the version and frame go as scalars (the API wraps a scalar in an array) and
    // the hour can be [null], none of which `ListSearchOptions['filters']` can express.
    'filter.audience_version_id': audienceVersionId,
    'filter.f_day': days,
    'filter.f_hour': [hour ? `>=${hour}` : null],
    'filter.valid_from': [`>=${formatDateToFirstOfMonth(date)}`],
    'filter.frame_id': frameId,
});
